import { render, staticRenderFns } from "./NotificationListing.vue?vue&type=template&id=f47c3aba&scoped=true"
import script from "./NotificationListing.vue?vue&type=script&lang=js"
export * from "./NotificationListing.vue?vue&type=script&lang=js"
import style0 from "./NotificationListing.vue?vue&type=style&index=0&id=f47c3aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47c3aba",
  null
  
)

export default component.exports